import React, { CSSProperties, ReactElement } from 'react'
import { capitalize } from 'lodash'
import { colors } from '@lmc/common/constants'

interface Option {
  label?: string
  value: any
}

interface ModalQuestionProps {
  note?: string
  onChange: any
  options: Option[]
  question: string
  style?: CSSProperties
}

const ModalQuestion: React.FC<ModalQuestionProps> = ({
  note,
  onChange,
  options,
  question,
  style,
}): ReactElement => (
  <div className="lmc-card" style={style}>
    <span style={styles.question}>{question}</span>
    <span style={styles.note}>{note}</span>
    <div style={styles.options}>
      {options.map((option) => (
        <div
          className="lmc-option-field"
          key={option.value}
          onClick={() => onChange(option)}
          style={styles.optionContainer}
        >
          <span style={styles.option}>
            {option.label || capitalize(option.value)}
          </span>
        </div>
      ))}
    </div>
  </div>
)

const styles: { [key: string]: CSSProperties } = {
  question: {
    display: 'block',
    fontWeight: 'bold',
    fontSize: 18,
    whiteSpace: 'pre-wrap',
  },
  note: {
    fontSize: 12,
    color: colors.darkgrey,
  },
  option: {
    transition: 'font-weight .2s ease',
  },
  optionContainer: {
    borderColor: colors.grey,
  },
  options: {
    display: 'flex',
    marginTop: 12,
  },
}

export default ModalQuestion
